import type React from 'react';

export const btn = (active: boolean, color?: string): React.CSSProperties => ({
  flex: 1,
  border: `1.5px solid ${active ? 'transparent' : '#eee'}`,
  borderRadius: 6,
  padding: '3px 1px',
  fontSize: 10,
  fontFamily: "'DM Mono',monospace",
  cursor: 'pointer',
  background: active ? (color ?? '#555') : 'white',
  color: active ? 'white' : '#888',
  lineHeight: 1.3,
  textAlign: 'center',
  transition: 'all 0.15s',
});

export const label: React.CSSProperties = {
  fontSize: 9,
  textTransform: 'uppercase',
  letterSpacing: '.07em',
  color: '#aaa',
  textAlign: 'center',
};

export const divider: React.CSSProperties = { height: 1, background: '#f0ece4' };

export const inputStyle: React.CSSProperties = {
  fontFamily: "'Caveat',cursive",
  fontSize: 12,
  textAlign: 'center',
  border: '1.5px solid #ddd',
  borderRadius: 6,
  padding: '3px 8px',
  color: '#666',
  outline: 'none',
  width: '100%',
};

export const monoInputStyle: React.CSSProperties = {
  fontFamily: "'DM Mono',monospace",
  fontSize: 11,
  textAlign: 'center',
  border: '1.5px solid #ddd',
  borderRadius: 6,
  padding: '3px 8px',
  color: '#666',
  outline: 'none',
  width: '100%',
};

export const sectionStyle: React.CSSProperties = {
  display: 'grid',
  gap: 6,
  border: '1px solid #eee8de',
  borderRadius: 8,
  padding: 8,
  background: '#fffdfa',
};

export const sectionTitleStyle: React.CSSProperties = {
  ...label,
  margin: 0,
  textAlign: 'left',
  color: '#8b8272',
};

export const hintStyle: React.CSSProperties = {
  fontSize: 10,
  color: '#7d7d7d',
  textAlign: 'center',
  margin: '2px 0 0 0',
};

export const chipGridStyle: React.CSSProperties = {
  display: 'grid',
  gap: 4,
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
};

export const tagStyle: React.CSSProperties = {
  borderRadius: 999,
  padding: '2px 8px',
  border: '1px solid #e6dfd1',
  color: '#7f7460',
  fontSize: 10,
  fontFamily: "'DM Mono',monospace",
};

export const ghostButtonStyle: React.CSSProperties = {
  border: '1px solid #e1ddd4',
  borderRadius: 6,
  background: 'white',
  color: '#7d7468',
  fontSize: 10,
  cursor: 'pointer',
  padding: '4px 8px',
};

export const actionButtonStyle: React.CSSProperties = {
  flex: 1,
  border: 'none',
  borderRadius: 8,
  fontFamily: "'DM Mono',monospace",
  fontSize: 12,
  cursor: 'pointer',
  padding: '8px 10px',
};

export const headerCardStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 12,
  border: '1px solid #ebe6db',
  borderRadius: 12,
  padding: '10px 12px',
  background: 'linear-gradient(180deg, #fffcf7 0%, #fffaf2 100%)',
};

export const contextGridStyle: React.CSSProperties = {
  display: 'grid',
  gap: 8,
  gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
};
